import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MzicArtistLocalService } from '../mzic-artist-local/mzic-artist-local.service';
import { MzicLoginStateService } from '../mzic-login-state/mzic-login-state.service';
import { MzicTokenLocalService } from '../mzic-token-local/mzic-token-local.service';
import { RegistrationStateService } from '../registration-state/registration-state.service';

@Injectable({
  providedIn: 'root',
})
export class IncompleteRegistrationMonitorService {
  private checkInterval: any;

  constructor(
    private readonly _tokenService: MzicTokenLocalService,
    private readonly _artistLocalService: MzicArtistLocalService,
    private readonly _loginStateService: MzicLoginStateService,
    private readonly _registrationStateService: RegistrationStateService,
    private readonly _router: Router,
    private readonly dialog: MatDialog,
  ) {
    this.startMonitoring();
  }

  /**
   * Starts monitoring for expired incomplete registrations
   */
  private startMonitoring(): void {
    // Check every minute for expired registrations
    this.checkInterval = setInterval(() => {
      this.checkExpiredRegistrations();
    }, 60000); // 1 minute

    // Also check immediately on service initialization
    setTimeout(() => {
      this.checkExpiredRegistrations();
    }, 1000);
  }

  /**
   * Checks for and cleans up expired incomplete registrations
   */
  public checkExpiredRegistrations(): void {
    if (this._tokenService.isIncompleteRegistrationExpired()) {
      // Close all open dialogs before cleaning up and redirecting
      this.dialog.closeAll();

      this.cleanupIncompleteRegistration('automatic_cleanup_expired');

      // Redirect to login if user is on a protected route
      const currentUrl = window.location.pathname;
      if (this.isProtectedRoute(currentUrl)) {
        this._router.navigate(['/login']);
      }
    }
  }

  /**
   * Manually trigger cleanup of incomplete registration
   */
  public cleanupIncompleteRegistration(reason: string): void {
    console.log(
      `[Registration Monitor] Cleaning up incomplete registration. Reason: ${reason}`,
    );

    // Clear ALL authentication and registration data
    this._tokenService.clearAlltokens(); // This includes token registration state
    this._artistLocalService.removeDataUSerTo2FA();
    this._loginStateService.clearState();
    this._registrationStateService.clearRegistrationState();

    // Clear any other user-specific cached data
    localStorage.removeItem('user-preferences');
    localStorage.removeItem('mzic-viberate-uuid');
    localStorage.removeItem('mzic-all-teams-local');
    localStorage.removeItem('mzic-wallet-team');

    console.log(
      `[Registration Monitor] All incomplete registration data cleared`,
    );
  }

  /**
   * Setup beforeunload listener to clean up on browser close/refresh
   */
  public setupBrowserCloseCleanup(): void {
    window.addEventListener('beforeunload', () => {
      if (this._tokenService.hasIncompleteRegistration()) {
        this.cleanupIncompleteRegistration('browser_close_or_refresh');
      }
    });
  }

  /**
   * Checks if current route requires protection from incomplete registration
   */
  private isProtectedRoute(url: string): boolean {
    const protectedRoutes = [
      '/dashboard',
      '/team-selection',
      '/catalogue',
      '/wallet',
      '/settings',
    ];

    return protectedRoutes.some((route) => url.includes(route));
  }

  /**
   * Stop monitoring (cleanup)
   */
  public stopMonitoring(): void {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  }
}
